import React, { useEffect, useRef } from "react";

// Confeti ligero para el hero público (Part B). Respeta prefers-reduced-motion
// y se limpia completamente al desmontar (sin fugas de memoria).
export const Pp2Confetti = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;

    const ctx = canvas.getContext("2d");
    let raf;
    let width = 0;
    let height = 0;
    const colors = ["#e8366e", "#f5a623", "#9b7bff", "#3fd0a4"];
    const COUNT = 26;
    const pieces = Array.from({ length: COUNT }, () => ({
      x: Math.random(),
      y: Math.random(),
      r: 2 + Math.random() * 3,
      c: colors[Math.floor(Math.random() * colors.length)],
      vy: 0.0004 + Math.random() * 0.0006,
      vx: (Math.random() - 0.5) * 0.0003,
    }));

    const resize = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      width = canvas.width = rect.width;
      height = canvas.height = rect.height;
    };
    resize();
    window.addEventListener("resize", resize);

    const tick = () => {
      ctx.clearRect(0, 0, width, height);
      pieces.forEach((p) => {
        p.y += p.vy;
        p.x += p.vx;
        if (p.y > 1) p.y = -0.05;
        if (p.x > 1) p.x = 0;
        if (p.x < 0) p.x = 1;
        ctx.fillStyle = p.c;
        ctx.globalAlpha = 0.55;
        ctx.beginPath();
        ctx.arc(p.x * width, p.y * height, p.r, 0, Math.PI * 2);
        ctx.fill();
      });
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} className="pp2-fx" aria-hidden="true" data-testid="pp2-hero-confetti" />;
};
